import styled from 'styled-components';

export default comp => styled(comp)`
  .block-heading {
    position: relative;
    z-index: 10;

    // TODO: Remove happy houses
    //svg {
    //   opacity: 0;
    //   transition: all 0.4s ease-in-out;
    //   transition-delay: 0.4s;
    // }

    // &.active {
    //   svg {
    //     opacity: 1;
    //   }
    // }

    // .icons {
    //   @media (max-width: ${props => props.theme.breakpoints.desktop}) {
    //     display: none;
    //   }
    // }

    // .icon {
    //   &-parachute_house {
    //     position: absolute;
    //     top: -3.25rem;
    //     left: calc(
    //       ((100% - ${props => props.theme.maxWidths.content}) / 2) - 12.9375rem
    //     );
    //     animation: houseRock ease-in-out 4s alternate infinite;
    //     transform-origin: 50% 50%;
    //   }

    //   &-smiling_sun {
    //     position: absolute;
    //     top: 0.8125rem;
    //     right: calc(
    //       ((100% - ${props => props.theme.maxWidths.content}) / 2) - 12.9375rem
    //     );

    //     &--rays {
    //       animation: sunRaysLoop linear 15s forwards infinite;
    //       transform-origin: 50% 50%;
    //     }
    //   }
    // }
  }

  // ${props => props.theme.animations.houseRock}
  // ${props => props.theme.animations.sunRaysLoop}
`;
